<form [formGroup]="beneficiaryForm">
  <div class="form">
    <div class="div"></div>
    <div class="lg:flex justify-between mb-5">
      <div class="mb-1">
        <div class="font-bold">Informations personnelles</div>
        <div class="text-sm">
          Mettez à jour votre photo et vos coordonnées personnelles ici.
        </div>
      </div>
    </div>

    <hr class="h-px bg-gray-300 border-0 dark:bg-gray-700 my-6" />

    <div class="grid" style="display: flex">
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <label for="prenom" class="block font-medium leading-6">
          <div class="mb-1 font-semibold text-sm">Prénom</div>
        </label>
        <div class="col-span-2">
          <input
            type="text"
            id="prenom"
            required=""
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"
            formControlName="firstname"
          />
        </div>
      </div>

      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <label for="lastname" class="block font-medium leading-6">
          <div class="mb-1 font-semibold text-sm">Nom</div>
        </label>
        <div class="col-span-2">
          <input
            type="text"
            id="lastname"
            required=""
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 h-15"
            value=""
            formControlName="lastname"
          />
        </div>
      </div>
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">
            <label for="sexe">Sexe</label>
          </div>
        </div>
        <div class="col-span-2">
          <div
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            {{ getSexeLabel(beneficiaryForm.get("sexe")?.value) }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Date de Naissance</div>
        </div>
        <div class="col-span-2">
          <div class="flex justify-between gap-3">
            <select
              formControlName="selectedDay"
              id="days"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option *ngFor="let day of days" [value]="day.id">
                {{ day.id }}
              </option>
            </select>
            <select
              formControlName="selectedMounth"
              id="mounth"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option *ngFor="let mounth of mounths" [value]="mounth.id">
                {{ mounth.name }}
              </option>
            </select>
            <select
              formControlName="selectedYear"
              id="year"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option *ngFor="let year of years" [value]="year.year">
                {{ year.year }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Nationalité</div>
        </div>
        <div class="col-span-2">
          <select
            formControlName="selectedNationality"
            id="countries"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option *ngFor="let country of countries" [value]="country.name">
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Pays de résidence</div>
        </div>
        <div class="col-span-2">
          <select
            formControlName="selectedCountry"
            id="countries"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option *ngFor="let country of countries" [value]="country.id">
              {{ country.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-12 md:col-12 xl:col-6 pb-2" *ngIf="isSenegalSelected">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Ville de résidence</div>
        </div>
        <div class="col-span-2">
          <select
            formControlName="selectedCity"
            id="city"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          >
            <option *ngFor="let city of cities" [value]="city.id">
              {{ city.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1">
            <label for="email" class="font-semibold text-sm"
              >Adresse e-mail</label
            >
          </div>
        </div>
        <div class="col-span-2">
          <input
            type="text"
            id="email"
            class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            [disabled]="true"
            formControlName="email"
          />
        </div>
      </div>

      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Numéro téléphone</div>
        </div>

        <div class="col-span-2">
          <div class="flex items-center">
            <select
              id="phoneCodeOne"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              formControlName="phoneCodeOne"
            >
              <option
                *ngFor="let country of phoneCode"
                [value]="country.phoneCode"
              >
                +{{ country.phoneCode }}
              </option>
            </select>

            <input
              type="text"
              id="phone_number_one"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-r-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder=""
              required
              formControlName="phoneNumberOne"
              onlyNumber
            />
          </div>
        </div>
      </div>

      <!-- deuxieme div -->
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Numéro Whatsapp</div>
        </div>

        <div class="col-span-2">
          <div class="flex items-center">
            <select
              id="phoneCodeOne"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              formControlName="phoneCodeOne"
            >
              <option
                *ngFor="let country of phoneCode"
                [value]="country.phoneCode"
              >
                +{{ country.phoneCode }}
              </option>
            </select>

            <input
              type="text"
              id="phone_number_one"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-r-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              placeholder=""
              required
              formControlName="phoneNumberOne"
              onlyNumber
            />
          </div>
        </div>
      </div>

      <!-- troisieme div -->
      <div class="col-12 md:col-12 xl:col-6 pb-2">
        <div class="label">
          <div class="mb-1 font-semibold text-sm">Numéro Wave</div>
        </div>

        <div class="col-span-2">
          <div class="flex items-center">
            <select
              id="phoneCodeThree"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-l-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              formControlName="phoneCodeWave"
            >
              <option
                *ngFor="let country of phoneCode"
                [value]="country.phoneCode"
              >
                +{{ country.phoneCode }}
              </option>
            </select>
            <input
              type="text"
              id="default-search"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-r-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              required
              formControlName="phoneNumberWave"
              onlyNumber
            />
          </div>
        </div>
      </div>
    </div>

    <div class="flex items justify-end">
      <div *ngIf="succes" class="text-green-700">
        <strong>Mises à jour reussie</strong>
      </div>
      <div *ngIf="error" class="text-red-700">
        <strong>Erreur. Essayez plus tard</strong>
      </div>
    </div>
    <br />

    <div class="flex justify-end mt-6">
      <div>
        <button
          type="button"
          class="border border-gray-300 transition hover:bg-gray-100 font-semibold rounded-lg text-sm px-5 py-2.5 me-2 mb-2"
        >
          Annuler
        </button>
        <button
          type="button"
          class="text-white btn-login transition rounded-lg text-sm px-5 py-2.5 me-2 mb-2 bg-blue font-semibold"
          (click)="onSubmitForm()"
          [disabled]="beneficiaryForm.pristine"
        >
          Enregistrer
        </button>
      </div>
    </div>
  </div>
</form>
